import { useEffect } from "react";
import Seo from "@/components/Seo";

const H2 = "font-serif text-2xl text-charcoal-800 mt-10 mb-3";
const P = "text-charcoal-600 leading-relaxed mb-4";

export default function Privacy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="page-privacy">
      <Seo
        title="Privacy Notice / Aviso de Privacidad"
        description="How Hola Movers collects, uses, and protects your personal data, in accordance with Mexico's LFPDPPP."
        path="/privacy"
      />
      <section className="mx-auto max-w-3xl px-6 lg:px-12 pt-16 lg:pt-24 pb-20">
        <p className="text-sm uppercase tracking-[0.2em] text-clay-700 font-medium mb-4">Legal</p>
        <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-charcoal-900 leading-[1.05]">
          Privacy Notice
        </h1>
        <p className="mt-3 text-charcoal-500 italic">Aviso de Privacidad</p>

        <p className="mt-4 text-sm text-charcoal-600" data-testid="privacy-policy-links">
          See also our <a href="/review-policy" className="text-terracotta underline">Review Policy</a> and <a href="/photo-policy" className="text-terracotta underline">Photo Policy</a>.
        </p>

        <h2 className={H2}>Who we are (Responsable)</h2>
        <p className={P}>
          Hola Movers, based in Mérida, Yucatán, México ("we", "us"), is responsible for the personal
          data you share with us through this website, in accordance with the Ley Federal de Protección
          de Datos Personales en Posesión de los Particulares (LFPDPPP).
        </p>

        <h2 className={H2}>What data we collect</h2>
        <p className={P}>
          When you contact us, book a consultation, request a quote, or use the client portal, we may
          collect: your name, email address, phone number, your current location and intended destination,
          your moving timeline, payment confirmation details (processed securely by Stripe — we never store
          card numbers), and documents you voluntarily upload to your client portal.
        </p>

        <h2 className={H2}>Why we collect it (Finalidades)</h2>
        <p className={P}>
          We use your data to: respond to your inquiries, prepare and send relocation quotes, schedule and
          hold consultations, coordinate your move, process deposits, and send you service-related
          confirmations and reminders. With your consent, we may also send occasional planning tips by email.
          We do not sell or rent your personal data to third parties.
        </p>

        <h2 className={H2}>Who processes it</h2>
        <p className={P}>
          To operate the service we rely on trusted providers: Stripe (payments), Resend (transactional
          email), and secure cloud storage for documents you upload. Each processes data only as needed to
          deliver the service.
        </p>

        <h2 className={H2}>Your ARCO rights</h2>
        <p className={P}>
          You have the right to Access, Rectify, Cancel, or Oppose (ARCO) the use of your personal data, and
          to withdraw consent at any time. To exercise these rights, email us at{" "}
          <a
            data-testid="privacy-arco-email"
            href="mailto:info@holamovers.com?subject=ARCO%20Request%20%E2%80%94%20HolaMovers"
            className="text-terracotta underline underline-offset-2"
          >
            info@holamovers.com
          </a>{" "}
          with the subject "ARCO Request". We will respond within the timeframes established by the LFPDPPP.
        </p>

        <h2 className={H2}>Changes to this notice</h2>
        <p className={P}>
          We may update this notice from time to time. The current version will always be available at
          holamovers.com/privacy.
        </p>

        <p className="mt-8 text-sm text-charcoal-400">
          Última actualización / Last updated: June 2026. Para asistencia en español, escríbenos a
          info@holamovers.com.
        </p>
      </section>
    </div>
  );
}
